import {COOKIE_JWT, COOKIE_REMEMBER} from './constant';
import {removeCookie, setCookie} from './cookie';
import {changeToSlug} from './string.helper';
import moment from 'moment';

const reEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const rePhone = /^[0-9]{7,10}$/;

export function redirectLogout(_ctx = null) {
    if (process.browser) {
        removeCookie(COOKIE_JWT);
        removeCookie(COOKIE_REMEMBER);
        // window.location.href = "/dang-nhap"
    }
}

export function formatPrice(x, isShow = true) {
    if (!x) return '0' + (isShow ? ' đ' : '');
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (isShow ? ' đ' : '');
}

export const convertValue = (value, options) => {
    if (!(typeof value === 'object') && options && options.length) {
        value = (_val => {
            return options.find(item => '' + item.value === '' + _val);
        })(value);
    } else if (Array.isArray(value) && options && options.length) {
        return options.filter(item => {
            return value.find(e => e == item.value);
        });
    }
    return value;
};

export function uid() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
}

export const urlAPI = `${process.browser ? process.env.NEXT_PUBLIC_API : process.env.API}`;

export const getBreadcrumb = (categories = []) => {
    if (categories && categories.length) {
        let breadcrumb = categories.map(cate => {
            return {
                id: cate.category_id,
                name: cate.category_name,
                seo_url: `${changeToSlug(cate.category_name)}-c${cate.category_id}`,
            };
        });
        return breadcrumb;
    }
    return [];
};

export const formatDatePost = value => {
    let value_replace = moment(value, 'YYYY-MM-DD h:mm:ss').fromNow(true);
    value_replace = value_replace
        .replace('a few seconds', 'Vừa xong')
        .replace('seconds', 'giây trước')
        .replace('a minute', '1 phút trước')
        .replace('minutes', 'phút trước')
        .replace('an hour', '1 giờ trước')
        .replace('hours', 'giờ trước')
        .replace('a day', '1 ngày trước')
        .replace('days', 'ngày trước')
        .replace('a month', '1 tháng trước')
        .replace('months', 'tháng trước')
        .replace('a year', '1 năm trước')
        .replace('years', 'năm trước');
    return value_replace;
};

export function sortObject(obj) {
    var sorted = {};
    var str = [];
    var key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            str.push(encodeURIComponent(key));
        }
    }
    str.sort();
    for (key = 0; key < str.length; key++) {
        sorted[str[key]] = encodeURIComponent(obj[str[key]]).replace(/%20/g, '+');
    }
    return sorted;
}

export const validateEmail = email => {
    if (!email) return false;
    return reEmail.test(String(email).toLowerCase());
};

export const validatePhone = phone => {
    if (!phone) return false;
    return rePhone.test(String(phone).toLowerCase());
};

export const getErrorMessage = (error, msg = 'Đã có lỗi xảy ra. Vui lòng F5 thử lại') => {
    if (typeof error === 'string') return error;

    if (error instanceof Array) {
        let objErr = {};
        error.forEach(err => {
            objErr[err.key] = err.msg;
        });
        return JSON.stringify(objErr);
    }

    let _message = '';

    if (typeof error === 'object') {
        let {message = '', errmsg = ''} = error || {};
        _message = message || msg || errmsg;
    } else {
        _message = msg;
    }
    return _message;
};

export function isVideo(filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
        case 'm4v':
        case 'avi':
        case 'mpg':
        case 'mp4':
        case 'mov':
            return true;
    }
    return false;
}

export function getExtension(filename) {
    var parts = filename.split('.');
    return parts[parts.length - 1];
}

export const validateVideo = file => {
    if (!isVideo(file.name)) {
        return 'Chỉ được phép sử dụng tập tin video.';
    }
    const isLt100M = file.size / 1024 / 1024 < 100;
    if (!isLt100M) {
        return 'Dung lượng tập tin tối đa là 100MB.';
    }
    return true;
};

export const formatPoint = x => {
    if (!x) return 0;
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ' ');
};

export function splitString(str, n, useWordBoundary = true) {
    if (!str) return '';
    if (str.length <= n) {
        return str;
    }
    const subString = str.substr(0, n - 1);
    return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '...';
}

export const isValidDoctorTime = (timeValue, calendarDoctor = []) => {
    if (!Array.isArray(calendarDoctor) || calendarDoctor.length === 0) {
        return false;
    }
    if (!timeValue) return true;
    const selected = moment(timeValue);
    const validSlot = calendarDoctor.find(slot => {
        if (!slot || slot.available_slot <= 0) return false;

        const start = moment(`${slot.work_date} ${slot.start_time}`, 'DD/MM/YYYY HH:mm');

        const end = moment(`${slot.work_date} ${slot.end_time}`, 'DD/MM/YYYY HH:mm');

        return selected.isSame(start, 'day') && selected.isBetween(start, end, null, '[)');
    });
    return !!validSlot;
};
